export default "__VITE_ASSET__BxkYg_ZA__"